import { UuiAlert } from "@aonunited/react";
import React from "react";
var AonAlert = function (_a) {
    var header = _a.header, _b = _a.hideClose, hideClose = _b === void 0 ? false : _b, _c = _a.type, type = _c === void 0 ? "banner" : _c, _d = _a.variant, variant = _d === void 0 ? "notification" : _d, _e = _a.visible, visible = _e === void 0 ? true : _e, children = _a.children, onClose = _a.onClose;
    return (React.createElement(React.Fragment, null,
        React.createElement(UuiAlert, { variant: variant, visible: visible, type: type, hideClose: hideClose, header: header, onClose: onClose }, children)));
};
export { AonAlert };
